<template>
  <div id="next_page" @click="next" :style="{background : colors.secondary, borderBottom: `4px solid ${colors.theme == 'dark' ? '#001324' : '#cecece'}`}">
    <span>{{title}}</span>
    <div v-if="arrow" class="arrow_right"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colors: {}
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },
  props: {
    title: {
      type: String,
      required: true
    },
    nextRoute: {
      type: String,
      required: true
    },
    arrow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    widthText() {
      return this.arrow == true ? "90" : "100";
    }
  },
  methods: {
    next() {
      this.$router.push(`${this.nextRoute}`);
    }
  }
};
</script>

<style lang="scss" scoped>
#next_page {
  display: flex;
  align-items: center;
  text-align: center;
  min-width: 255px;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  padding: 23px;
  border-radius: 200px;
  border-bottom: 4px solid;

  span {
    letter-spacing: 3px;
    text-transform: uppercase;
    width: 100%;
    font-size: 20px;
    position: relative;
    left: 11px;
 
  }

  .arrow_right {
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #fff;
    width: 10%;
    position: relative;
    left: 4%;
  }
}

@media only screen and (max-width: 650px) {
  #next_page {
    span {
      font-size: 14px;
    }
  }
}
@media only screen and (max-width: 430px) {
  #next_page {
    span {
      font-size: 15px;
    }
  }
}
@media only screen and (max-width: 320px) {
  #next_page {
    span {
      font-size: 17px;
    }
  }
}
</style>

